import{a as r}from"./chunk-XSBUL2WP.mjs";var i=class{constructor(n){this.config=n}async viewBinary(n){return r({...n,aptosConfig:this.config})}};export{i as a};
//# sourceMappingURL=chunk-CXLNTATW.mjs.map